import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SyncStatusOptions} from '../../../../utils/helpers';
import BaseTableFilters from '../../NetSuiteBillsPage/TableFilters';

const TableFilters = ({
  ...rest
}) => {
  const [t] = useTranslation('main');

  const [statusOptions, ] = useState([
    {label: t('allStatuses'), value: 'all'},
    ...SyncStatusOptions(),
  ]);

  return (
    <BaseTableFilters
      statusOptions={statusOptions}
      {...rest}
    />
  );
};

export default TableFilters;
